import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import styles from "./CartLogin.module.css";
import {Alert, Button, Grid2, Link} from "@mui/material";
import CustomTextField from "../../../components/customMUIComponents/CustomTextField";
import Typography from "@mui/material/Typography";
import useLogin from "../../../hooks/useLogin";
import {useSectionsRefs} from "../../../components/mainWrapper/MainWrapper";
import useAuth from "../../../hooks/useAuth";
import {useNavigate} from "react-router-dom";

const CartLogin = () => {

    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');

    const {login, error} = useLogin();

    const handleSubmitLogin = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        login(email, password, '/cart');
    }

    const {setNavItems, setDisplayRegisterSocietyButton, setDisplayCart, setDisplayMobileMenu} = useSectionsRefs();

    useEffect(() => {
        setNavItems([]);
        setDisplayRegisterSocietyButton(false);
        setDisplayCart(false);
        setDisplayMobileMenu(false);
    }, []);

    const {auth} = useAuth();

    const navigate = useNavigate();

    useEffect(() => {
        if (auth.token) {
            navigate('/cart')
        }
    }, []);

    return (
        <Box sx={{
            width: "100%",
            backgroundColor: 'primary.main',
            alignContent: 'center'
        }}>

            <Box
                sx={{
                    backgroundColor: "primary.main",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <div className={styles.content}>
                    <div className={styles.realContent}>
                        <Grid2 container size={12} padding={4}>
                            <Grid2 offset={{xs: 0, sm: 3}} size={{xs: 12, sm: 6}} borderBottom={"1px solid gray"} pb={4}>
                                <Typography
                                    variant={"secondVariant"}
                                    fontSize={{xs: '18px', sm: '20px', md: '22px'}}
                                    mb={2}
                                >
                                    Connexion
                                </Typography>
                                <form onSubmit={(e) => handleSubmitLogin(e)}>
                                    <CustomTextField
                                        value={email}
                                        label="Email"
                                        mb={4}
                                        type="email"
                                        required
                                        setField={setEmail}
                                        variant="outlined"
                                    />
                                    <CustomTextField
                                        value={password}
                                        label="Mot de passe"
                                        mb={4}
                                        type="password"
                                        required
                                        setField={setPassword}
                                        variant="outlined"
                                    />
                                    <Button
                                        variant={"firstVariant"}
                                        fullWidth={true}
                                        type={"submit"}
                                    >
                                        Se connecter
                                    </Button>

                                    {error && (
                                        <Alert
                                            severity="error"
                                            sx={{mt: 4}}
                                        >
                                            L'adresse email ou le mot de passe est incorrect.
                                        </Alert>
                                    )}
                                </form>
                            </Grid2>

                            <Grid2 offset={{xs: 0, sm: 3}} size={{xs: 12, sm: 6}} borderBottom={"1px solid gray"} mt={4} pb={4}>
                                <Button
                                    variant={"secondVariant"}
                                    fullWidth={true}
                                    onClick={() => navigate('/cart')}
                                >
                                    Acheter en tant que visiteur
                                </Button>
                            </Grid2>

                            <Grid2 offset={{xs: 0, sm: 3}} size={{xs: 12, sm: 6}} mt={4}>
                                <Link
                                    href={"https://looty.ch/create-account"}
                                    variant={"firstVariant"}
                                >
                                    Pas encore de compte ? Inscris-toi
                                </Link>
                            </Grid2>
                        </Grid2>
                    </div>
                </div>
            </Box>
        </Box>
    )
}

export default CartLogin